import { useState } from 'react';
import { GENERATE_SHARE_URL } from '../../Utils/apis';

const useGenerateShareUrl = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [shareUrl, setShareUrl] = useState('');
  const [num , setNum] = useState(1);

  const generateShareUrl = async () => {
    setError('');
    if (!loading) {
      try {
        setLoading(true);
        const response = await fetch(GENERATE_SHARE_URL, {
          method: 'POST',
          body: JSON.stringify({ share_num: num }),
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include',
        });
        if (!response.ok) {
          const err = await response.json();
          throw new Error(err.message || 'Failed to generate share URL');
        }

        const data = await response.json();

        if (data.data) {
          setShareUrl(data.data);
        } else {
          throw new Error('No share URL found in response.');
        }
      } catch (err) {
        setError(err.message);
        setShareUrl('');
      } finally {
        setLoading(false);
      }
    }
  };

  return [loading, error, shareUrl, generateShareUrl];
};

export default useGenerateShareUrl;
